import RunScreenerInputContainerFieldsFragment from "components/screener/v2/query/RunScreenerInputContainerFieldsFragment";
import ScreenerIndicatorFieldsFragment from "components/screener/v2/query/ScreenerIndicatorFieldsFragment";
import gql from "graphql-tag";
const StoreRunScreenerInputMutation = gql`
  mutation StoreRunScreenerInput($input: StoreRunScreenerInput!) {
    storeRunScreenerInput(input: $input) {
      objectId
      ...RunScreenerInputContainerFields
      selectedIndicators {
        ...ScreenerIndicatorFields
      }
    }
  }
  ${RunScreenerInputContainerFieldsFragment}
  ${ScreenerIndicatorFieldsFragment}
`;
export default StoreRunScreenerInputMutation;
